import { useQuery } from "@apollo/client";
import { generateQuarterlyDates } from "@asmbl/shared/utils";
import { Box } from "@mui/material";
import { BarChart } from "../../components/Visualization/BarChart";
import { TimelineSeriesChart } from "../../components/Visualization/TimelineSeriesChart";
import { VisualizationCard } from "../../components/Visualization/VisualizationCard";
import { GET_EMPLOYEE_ANALYTICS_COUNTS_AND_TIMESERIES } from "../../queries";
import { formatDateString } from "../../utils";
import { GetEmployeeAnalytics } from "../../__generated__/graphql";
import { TimeUnit, ToggleType } from "./Demographics";

interface Props {
  timeUnit: string;
  toggle: ToggleType;
}

export function EthnicityRepresentationChart({
  timeUnit,
  toggle,
}: Props): JSX.Element {
  const lastYearDates: string[] = generateQuarterlyDates().map((date) =>
    formatDateString(date)
  );

  const { data: employeeDataByEthnicity, loading } =
    useQuery<GetEmployeeAnalytics>(
      GET_EMPLOYEE_ANALYTICS_COUNTS_AND_TIMESERIES,
      {
        variables: {
          groupByFilterOpts: { groupBy: "ethnicity" },
          allTimeSeriesOpts: { dates: [], groupBy: "ethnicity" },
          lastYearTimeSeriesOpts: {
            dates: lastYearDates,
            groupBy: "ethnicity",
          },
        },
      }
    );

  const employeeCount = employeeDataByEthnicity?.employeeAnalytics.count ?? [];
  const allTimeSeriesData =
    employeeDataByEthnicity?.employeeAnalytics.allTimeTimeSeries ?? [];
  const lastYearTimeSeriesData =
    employeeDataByEthnicity?.employeeAnalytics.lastYearTimeSeries ?? [];

  return (
    <Box flex={1}>
      <VisualizationCard title="Ethnicity" loading={loading}>
        {timeUnit === TimeUnit.TODAY ? (
          <>
            <Box mt={2} />
            <BarChart
              items={employeeCount}
              height="210px"
              showPercentages={toggle === ToggleType.PERCENT}
            />
          </>
        ) : (
          <TimelineSeriesChart
            items={
              timeUnit === TimeUnit.LAST_YEAR
                ? lastYearTimeSeriesData
                : allTimeSeriesData
            }
            height="200px"
            showPercentages={toggle === ToggleType.PERCENT}
          />
        )}
      </VisualizationCard>
    </Box>
  );
}
